import script from "./BlockRecap.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockRecap.vue?vue&type=script&setup=true&lang=js"

import "./BlockRecap.vue?vue&type=style&index=0&id=72424432&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72424432"]])

export default __exports__